import React from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {CHECK__24} from '@homeaway/svg-defs';
import './slide-1.less';


export const Slide1 = ({
}) => (
    <div className="trip-board-onboarding-slide1">
        <div className="trip-board-onboarding-slide1__gray-circle"/>
        <div className="trip-board-onboarding-slide1__listings-circle"/>
        <div className="trip-board-onboarding-slide1__check-circle">
            <SVGIcon className="text-info" markup={CHECK__24} />
        </div>
        <div className="trip-board-onboarding-slide1__person1"/>
        <div className="trip-board-onboarding-slide1__person2"/>
        <div className="trip-board-onboarding-slide1__person3"/>
    </div>
);

export default Slide1;



// WEBPACK FOOTER //
// ./src/universal/components/onboarding/content/static/slide-1/slide-1.js